export const BREAK_POINTS = {
  isSmall: "(max-width: 400px)",
  isMediSmall: "(min-width: 401px)",
  isMedium: "(min-width: 601px)",
  isLarge: "(min-width: 901px)",
};
